/**
 * Marker that page templates put into the shop-cart success message instead of a ready text.
 * The cart page is created from a template, so a literal text would freeze the locale the
 * template was authored in. The token flags the message as "still the default", letting the
 * editor and the renderer substitute the `shop_cart_order_success_message` translation.
 */
export const DEFAULT_SUCCESS_MESSAGE_TOKEN = 'default_success_message';
